import React, { useState } from 'react';

import { useSelector } from 'editor/src/store/hooks';
import getHostSetting from 'editor/src/store/hostSettings/selector/getHostSetting';

import { RootState } from 'editor/src/store';
import useSpreadTitle from 'editor/src/util/design/useSpreadTitle';
import useBlobAsUrl from 'editor/src/util/useBlobAsUrl';

import IconLoading from 'editor/src/component/Icon/IconLoading';
import { useIsMobile } from 'editor/src/component/useDetectDeviceType';
import ZoomableImage from 'editor/src/component/ZoomableImage';

import styles from './index.module.scss';

interface Props {
  url?: string;
  blob: Blob | null;
  index: number;
  name?: string;
  spreadIndex?: number;
  showNameSetting?: boolean;
  isActive?: boolean;
}

function ListItem({ url, blob, name, spreadIndex, index, showNameSetting = false, isActive = true }: Props) {
  const blobUrl = useBlobAsUrl(blob);
  const imageUrl = url || blobUrl;
  const [loaded, setLoaded] = useState(false);
  const designData = useSelector((state: RootState) => state.design.designData);
  const isMobile = useIsMobile();
  // Phones keep the touch pinch / double-tap zoom; the mouse controls are for desktop.
  const desktopZoom =
    useSelector((state: RootState) => !!getHostSetting(state, 'canvasPanAndPreviewZoom')) && !isMobile;

  const spreadTitle = useSpreadTitle(
    spreadIndex !== undefined ? designData?.spreads[spreadIndex]?.name || '' : '',
    spreadIndex ?? index,
    undefined,
  );
  const showName = showNameSetting && spreadTitle;
  const handleImageLoad = () => {
    setLoaded(true);
  };

  return (
    <div className={styles.listItem}>
      <ZoomableImage
        src={imageUrl}
        alt={name || ''}
        draggable={false}
        onLoad={handleImageLoad}
        style={{ display: loaded ? 'block' : 'none' }}
        desktopZoom={desktopZoom}
        resetKey={isActive}
      />
      {!loaded && <IconLoading className={styles.loader} />}
      {showName && loaded && <div className={styles.label}>{spreadTitle}</div>}
    </div>
  );
}

export default React.memo(ListItem);
